// src/pageData.js — createPageDataHelper(payload) → `d`, a null-safe accessor over the PAGE payload
// contract (kind:"page"). Unlike the submission/list helpers it carries no form fields; it exposes the
// demo descriptor, screenshot metadata, and dashboard embeds, and reuses the SAME asset(name) → data-URI
// lookup as data.js / listData.js (bytes are server-inlined; never a public URL).

export function createPageDataHelper(payload, assets) {
  const safe = payload && typeof payload === 'object' ? payload : {};
  const assetMap = assets && typeof assets === 'object' ? assets : {};

  const demo = safe.demo && typeof safe.demo === 'object' ? safe.demo : {};
  const assetList = Array.isArray(safe.assets) ? safe.assets : [];
  const dashboards = Array.isArray(safe.dashboards) ? safe.dashboards : [];

  // Uploaded screenshots: name → data-URI. '' when missing so an <img src> degrades cleanly.
  function asset(name) {
    return (name && Object.prototype.hasOwnProperty.call(assetMap, name)) ? assetMap[name] : '';
  }

  return {
    raw: safe,
    demo,
    assets: assetList,
    dashboards,
    asset
  };
}

export default createPageDataHelper;
